import type { BaseComponentProps, Connotations } from "@neru/types";

export const svgImportKeys = [
  "add-user-line",
  "ai-line",
  "ai-solid",
  "app-store-line",
  "app-store-solid",
  "apps-line",
  "arrow-down-line",
  "arrow-down-solid",
  "arrow-left-line",
  "arrow-outbound-line",
  "arrow-right-line",
  "arrow-up-solid",
  "binoculars-line",
  "block-line",
  "books-solid",
  "bring-to-front-solid",
  "chain-line",
  "check-circle-line",
  "check-circle-solid",
  "check-line",
  "check-solid",
  "checkbox-checked-line",
  "checkbox-unchecked-line",
  "chevron-circle-down-solid",
  "chevron-down-line",
  "chevron-down-solid",
  "chevron-right-line",
  "chevron-right-solid",
  "chevron-up-solid",
  "clock-line",
  "clock-solid",
  "close-line",
  "close-small-line",
  "close-small-solid",
  "code-line",
  "code-solid",
  "company-line",
  "compose-line",
  "copy-2-line",
  "curly-brackets-line",
  "curly-brackets-solid",
  "delete-line",
  "density-high-solid",
  "document-2-line",
  "document-line",
  "edit-line",
  "envelope-line",
  "error-line",
  "error-solid",
  "error-star-line",
  "eye-hide-solid",
  "file-add-solid",
  "file-gear-line",
  "file-line",
  "file-search-line",
  "file-zip-line",
  "file-zip-solid",
  "filter-solid",
  "flash-2-solid",
  "flip-solid",
  "full-screen-line",
  "fullscreen-off-line",
  "gear-solid",
  "github-mono",
  "globe-line",
  "globe-solid",
  "group-line",
  "group-solid",
  "heart-solid",
  "help-line",
  "image-line",
  "info-line",
  "info-solid",
  "list-line",
  "lock-line",
  "lock-solid",
  "megaphone-solid",
  "message-solid",
  "more-vertical-line",
  "notification-on-line",
  "open-line",
  "packet-solid",
  "pie-chart-solid",
  "plus-line",
  "preferences-line",
  "puzzle-line",
  "refresh-line",
  "remove-user-line",
  "reorder-vertical-solid",
  "reset-line",
  "rocket-line",
  "rocket-solid",
  "sand-clock-line",
  "sand-clock-solid",
  "search-line",
  "share-2-line",
  "sort-asc-line",
  "sort-desc-line",
  "sort-line",
  "sparkles-line",
  "sparkles-solid",
  "star-line",
  "star-solid",
  "store-line",
  "stream-solid",
  "tag-line",
  "unlock-solid",
  "upload-line",
  "user-line",
  "wand-line",
  "warning-line",
  "warning-solid",
] as const;

export type IconType = (typeof svgImportKeys)[number];

enum IconSizes {
  large = "32px",
  medium = "24px",
  small = "16px",
}

export interface IconProps extends BaseComponentProps {
  connotation?: Connotations;
  customSize?: number;
  size?: keyof typeof IconSizes;
  style?: object;
  type: IconType;
}

const connotationColors = {
  alert: "fill-alert-600",
  announcement: "fill-announcement-600",
  cta: "fill-cta-600",
  info: "fill-info-400",
  primary: "fill-primary-950 dark:fill-primary-0",
  success: "fill-success-600",
  warning: "fill-warning-300",
};

export const Icon = ({
  className,
  connotation = "primary",
  customSize,
  "data-testid": testId,
  size = "medium",
  style = {},
  type,
}: IconProps) => {
  const iconSize = customSize ? `${customSize}px` : IconSizes[size];

  return (
    <svg
      className={[
        "bg-transparent inline-block",
        className?.includes("fill-") ? "" : connotationColors[connotation],
        className ?? "",
      ]
        .join(" ")
        .trim()}
      data-testid={testId ?? `icon-${type}`}
      height={iconSize}
      style={style}
      width={iconSize}
    >
      <use xlinkHref={`#${type}`}></use>
    </svg>
  );
};
